<template>
  <div class="columns is-gapless has-stickyColumn has-stickyColumn--left has-stickyColumn--right">
    <!-- DEBUT MENU -->
    <div class="column is-2 is-border has-bg-white">
      <aside class="menu menu-admin">
        <ul class="menu-list">
          <li :class="{'is-active' : panel === 'ADMINISTRATIF' || panel === 'FICHE_PROGRAMME' || panel === 'DOCUMENTATION' || panel === 'APPEL_DE_FOND'}">
            <a @click="panel = 'ADMINISTRATIF'">Information programme</a> 
            <ul class="">
              <li :class="{'is-active' : panel === 'ADMINISTRATIF'}"><a @click="panel = 'ADMINISTRATIF'" >
                <div class="is-uppercase">Administratif</div>
              </a></li>
              <li :class="{'is-active' : panel === 'FICHE_PROGRAMME'}"><a @click="panel = 'FICHE_PROGRAMME'" >
                <div class="is-uppercase">Fiche programme</div>
              </a></li>
              <li :class="{'is-active' : panel === 'DOCUMENTATION'}"><a :class="{'disabled' : isNew}" @click="!isNew ? panel = 'DOCUMENTATION' : null">
                <div class="is-uppercase">Documentation</div>
              </a></li>
              <!-- <li v-if="isPromoteurMode" :class="{'is-active' : panel === 'APPEL_DE_FOND'}"><a @click="panel = 'APPEL_DE_FOND'" > -->
              <li :class="{'is-active' : panel === 'APPEL_DE_FOND'}"><a :class="{'disabled' : isNew}" @click="!isNew ? panel = 'APPEL_DE_FOND' : null">
                <div class="is-uppercase">Appel de fonds</div>
              </a></li>
            </ul>
          </li>
          <!-- <li :class="{'is-active' : panel === 'LOTS_ET_PARKINGS'}"><a @click="panel = 'LOTS_ET_PARKINGS'">Lots et parkings</a></li> -->
        </ul>
      </aside>
    </div>
     <!-- FIN MENU -->
     
     <!-- DEBUT FORM -->
    <form class="column is-margin-left is-margin-right" @submit.prevent.stop="">

      <!-------------------------- DEBUT ADMINISTRATIF ----------------------->
      <div v-show="panel === 'ADMINISTRATIF'">
        <!-- DEBUT INFO WARNING -->
        <div v-if="!checkProgram" class="notification is-warning is-padding-left is-marginless is-min-height-50 is-flex">
          <div class="is-self-centered has-text-weight-medium has-text-left w100 is-uppercase is-size-7">
              <span class="icon is-small has-text-danger is-margin-right-small"><i class="fas fa-check-circle"></i></span>Information nécessaire à la validation de la fiche administrative
          </div>
        </div>
        <!-- FIN INFO WARNING -->

        <!-- DEBUT DONNEE PROGRAMME -->
        <div id="program-form" class="is-padding-left has-bg-white is-border is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-min-height-50 is-flex">
          <div class="is-self-centered"><span class="is-uppercase is-size-5">Données Programme</span></div>
        </div>
        <!-- FIN DONNEE PROGRAMME -->

        <!-- DEBUT INFO PROGRAMME -->
        <div class="column is-gapless is-paddingless has-bg-grey2 is-12 columns is-multiline">
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Nom du programme'" :value="privateProgram.name" :redCheck='true' :from-flux="fromFlux" data-type-cy="text" data-value-cy="input_prog_name_label"></r-label>
                <div class="control">
                  <v-input id="name" name="name" @input="val => privateProgram.name = val" :model="privateProgram.name"
                           v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val" classes="input"
                           data-vv-as="Nom du programme" data-type-cy="input" data-value-cy="input_prog_name">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-3 is-padding-left is-padding-right is-padding-top" v-if="isDistributeurMode">
              <div class="field">
                <r-label :label="'Promoteur'" :redCheck='true' :value="privateProgram.promoteur_name" :from-flux="fromFlux" data-type-cy="text" data-value-cy="input_promoter_label"></r-label>
                <div class="control">
                  <multiselect v-model="promoteurChange" id="promoteur" label="name" track-by="name"
                               :options="promoteurs"
                               :searchable="true" :close-on-select="true" :show-labels="false"
                               @search-change="getPromoteurs" :placeholder="''"
                               class="multiselect--option-ico"
                               :value="privateProgram.promoteur_name" data-type-cy="multiselect"
                               data-value-cy="multiselect_promoter">
                    <template slot="clear" slot-scope="props">
                      <div class="multiselect__clear" v-if="promoteurs.length"
                           @mousedown.prevent.stop="clearAll(props.search)"></div>
                    </template>
                    <span slot="noResult">Oups! Aucun promoteur trouvé.</span>
                    <span slot="placeholder" class="multiselect__placeholder">{{privateProgram.promoteur_name || 'Sélectionnez ou saisissez un promoteur'}}</span>
                    <span slot="noOptions">La liste est vide</span>
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="column is-3 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'N° référence'" :redCheck="hasCheck" :is-required="hasCheck" :value="privateProgram.ref" data-type-cy="text" data-value-cy="input_ref_label"></r-label>
                <div class="control">
                  <v-input v-if='hasCheck' id="ref" name="ref" @input="val => privateProgram.ref = val"
                           :model="privateProgram.ref" placeholder='Minimum quatre caractères'
                           v-validate="'required|min:4'" :errors-bag="errors" data-vv-value-path="val"
                           data-vv-as="N° référence" data-type-cy="input" data-value-cy="input_ref">
                  </v-input>
                  <v-input v-else id="ref" name="ref" @input="val => privateProgram.ref = val"
                           :model="privateProgram.ref" placeholder='Minimum quatre caractères'
                           v-validate="'min:4'" :errors-bag="errors" data-vv-value-path="val"
                           data-vv-as="N° référence" data-type-cy="input" data-value-cy="input_ref">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-12 is-padding-bottom">
              <div class="field">
                <div class="control">
                  <gmap-input :source="address" :geo-source="location" :geo-address="true" :is-required="true" :fromFlux="fromFlux"
                              label="Adresse du programme" :redCheck='true'
                              @submit="val => updateAddress(val, 'address')" data-type-cy="gmap" data-value-cy="program_address"></gmap-input>
                </div>
              </div>
            </div>
          </div>
          <!-- FIN INFO PROGRAMME -->

          <!-- DEBUT LIVRAISON PROGRAMME -->
          <div class="columns is-multiline has-bg-grey2 is-padding-bottom">
            <div class="column is-gapless is-paddingless is-12 columns is-multiline">
              <div class="column is-5 is-padding-left is-padding-right is-padding-top">
                <div class="field">
                  <label class="label" for="name" data-type-cy="text"
                        data-value-cy="select_delivery_label">Livraison</label>
                  <div class="control columns">
                    <div class="select is-fullwidth">
                      <select v-model="livraisonTrimestre" data-type-cy="select"
                              data-value-cy="select_delivery">
                        <option :value="null">Trimestre</option>
                        <option v-for="(t, i) in trims" :value="i + 1" :key="i">{{t[i + 1]}}
                        </option>
                      </select>
                    </div>
                    <div class="select is-fullwidth is-margin-left">
                      <select v-model="livraison" data-type-cy="select"
                              data-value-cy="select_delivery">
                        <option :value="null">Année</option>
                        <option v-for="year in years" :value="year" :key="year">{{year}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column is-1 is-padding-left is-padding-right is-padding-top">
              </div>
              <div class="column is-5 is-padding-left is-padding-right is-padding-top">
                <div class="field">
                  <label class="label" for="name" data-type-cy="text"
                        data-value-cy="select_actabilite_label">{{actabilityTerm}}</label>
                  <div class="control columns">
                    <div class="select is-fullwidth">
                      <select v-model="actabiliteTrimestre" data-type-cy="select"
                              data-value-cy="select_actabilite">
                        <option :value="null">Trimestre</option>
                        <option v-for="(t, i) in trims" :value="i + 1" :key="i">{{t[i + 1]}}
                        </option>
                      </select>
                    </div>
                    <div class="select is-fullwidth is-margin-left">
                      <select v-model="actabilite" data-type-cy="select"
                              data-value-cy="select_actabilite">
                        <option :value="null">Année</option>
                        <option v-for="year in years" :value="year" :key="year">{{year}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <!-- FIN LIVRAISON PROGRAMME -->

        <!-- DEBUT TERRAIN PERMIS DE CONSTRUIRE -->
        <div class="columns is-multiline has-bg-light is-padding-bottom">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5" data-type-cy="text" data-value-cy="notary_form_title">
              <b class="is-uppercase">Terrain - Permis de construire</b>
            </div>
          </div>
          <!-- DEBUT TERRAIN LIGNE 1 -->
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-4 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Référence cadrastrale'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.reference_cadrastrale" data-type-cy="text" data-value-cy="input_reference_cadrastrale_label"></r-label>
                <div class="control">
                  <v-input id="reference_cadrastrale" name="reference_cadrastrale" @input="val => privateProgram.reference_cadrastrale = val" 
                          :model="privateProgram.reference_cadrastrale"
                           v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val" classes="input"
                           data-vv-as="Référence cadrastrale" data-type-cy="input" data-value-cy="input_reference_cadrastrale">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-4 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Superficie terrain (en m2)'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.surface_terrain" data-type-cy="text" data-value-cy="input_surface_terrain_label"></r-label>
                <div class="control">
                  <v-input id="surface_terrain" name="surface_terrain" @input="val => privateProgram.surface_terrain = val" 
                          :model="privateProgram.surface_terrain"
                          input-type="number" :number="true"
                          v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val"
                          data-vv-as="Superficie terrain (en m2)">
                  </v-input>
                </div>
              </div>
            </div>
          </div>
          <!-- FIN TERRAIN LIGNE 1 -->

          <!-- DEBUT TERRAIN LIGNE 2 -->
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-4 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Numéro de PC'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.num_pc" data-type-cy="text" data-value-cy="input_num_pc_label"></r-label>
                <div class="control">
                  <v-input id="num_pc" name="num_pc" @input="val => privateProgram.num_pc = val" 
                          :model="privateProgram.num_pc"
                           v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val" classes="input"
                           data-vv-as="Numéro PC" data-type-cy="input" data-value-cy="input_num_pc">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-4 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Délivré par :'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.construction_licence_author" data-type-cy="text" data-value-cy="input_construction_licence_author_label"></r-label>
                <div class="control">
                  <v-input id="construction_licence_author" name="construction_licence_author" @input="val => privateProgram.construction_licence_author = val" 
                          :model="privateProgram.construction_licence_author"
                           v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val" classes="input"
                           data-vv-as="Délivré par :" data-type-cy="input" data-value-cy="input_construction_licence_author">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-4 is-padding-left is-padding-right is-padding-top">
              <r-label :label="'Date d\'autorisation du permis'" :value="privateProgram.construction_licence_date" :redCheck="hasCheck" :is-required="hasCheck"></r-label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded has-icons-right">
                  <flat-pickr :config="configDate" type="date" class="input" v-model="privateProgram.construction_licence_date"></flat-pickr>
                </div>
                <div class="control">
                  <a class="button is-grey is-inverted is-border is-min-width-0 is-square" @click="privateProgram.construction_licence_date = null">
                    <i class="fas fa-times"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- FIN TERRAIN LIGNE 2 -->

          <!-- DEBUT TERRAIN LIGNE 3 -->
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-2 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Nombre total de logements'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.total_lots" data-type-cy="text" data-value-cy="input_total_lots_label"></r-label>
                <div class="control">
                  <v-input id="total_lots" name="total_lots" @input="val => privateProgram.total_lots = val" 
                          :model="privateProgram.total_lots"
                          input-type="number" :number="true"
                          v-validate="''" :errors-bag="errors" data-vv-value-path="val"
                          data-vv-as="Nombre total de logement">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-2 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Nombre de bâtiment'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.total_buildings" data-type-cy="text" data-value-cy="input_total_buildings_label"></r-label>
                <div class="control">
                  <v-input id="total_buildings" name="total_buildings" @input="val => privateProgram.total_buildings = val" 
                          :model="privateProgram.total_buildings"
                          input-type="number" :number="true" :min="1"
                          v-validate="'min:1'" :errors-bag="errors" data-vv-value-path="val"
                          data-vv-as="Nombre de bâtiment">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-2 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Surface de plancher (en m2)'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.surface_plancher" data-type-cy="text" data-value-cy="input_surface_plancher_label"></r-label>
                <div class="control">
                  <v-input id="surface_plancher" name="surface_plancher" @input="val => privateProgram.surface_plancher = val" 
                          :model="privateProgram.surface_plancher"
                          input-type="number" :number="true"
                          v-validate="''" :errors-bag="errors" data-vv-value-path="val"
                          data-vv-as="Surface du plancher en m2">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-2 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Nombre total de parking'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.total_parking" data-type-cy="text" data-value-cy="input_total_parking_label"></r-label>
                <div class="control">
                  <v-input id="total_parking" name="total_parking" @input="val => privateProgram.total_parking = val" 
                          :model="privateProgram.total_parking"
                          input-type="number" :number="true"
                          v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val"
                          data-vv-as="Nombre total de parking">
                  </v-input>
                </div>
              </div>
            </div>
          </div>
          <!-- FIN TERRAIN LIGNE 3 -->

          <!-- DEBUT TERRAIN LIGNE 4 -->
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-12 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Aménagements prévus (séparer par une virgule)'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.planned_developments" data-type-cy="text" data-value-cy="input_planned_developments_label"></r-label>
                <div class="control">
                  <!-- <v-input id="planned_developments" name="planned_developments" @input="val => privateProgram.planned_developments = val" 
                          :model="privateProgram.planned_developments"
                           v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val" classes="input"
                           data-vv-as="Aménagements prévus" data-type-cy="input" data-value-cy="input_planned_developments">
                  </v-input> -->
                  <wysiwyg-editor :model="privateProgram.planned_developments" placeholder="" :submited='isSubmited'
                                  :class="{'editr--hide-toolbar':!displayToolbar}" :light-program='true' :light='true'
                                  @change="val => privateProgram.planned_developments = val"
                                  class="editr--bottom-toolbar editr--height-large content has-bg-white" />
                </div>
              </div>
            </div>
          </div>
          <!-- FIN TERRAIN LIGNE 4 -->

          <!-- DEBUT TERRAIN LIGNE 5 -->
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-4 is-padding-left is-padding-right is-padding-top">
              <label class="label">PC Déposé</label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-square is-border is-min-width-0">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded has-icons-right">
                  <flat-pickr type="date" class="input is-radiusless" v-model="pcDeposeDate"
                              :config="dateConfig"></flat-pickr>
                </div>
                <div class="control">
                  <a class="button is-grey is-inverted is-border is-square" @click="pcDeposeDate = null">
                    <i class="fal fa-times"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-2 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <span class="label is-margin-bottom-xxsmall">Étape Validée</span>
                <input id="pc_depose_validated" type="checkbox" name="pc_depose_validated"
                      class="switch is-success is-rounded is-medium"
                      v-model="privateProgram.pc_depose_validated">
                <label for="pc_depose_validated"></label>
              </div>
            </div>
            <div class="column is-4 is-padding-left is-padding-right is-padding-top">
              <label class="label">PC Purgé</label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-square is-border is-min-width-0">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded has-icons-right">
                  <flat-pickr type="date" class="input is-radiusless" v-model="pcPurgeDate"
                              :config="dateConfig"></flat-pickr>
                </div>
                <div class="control">
                  <a class="button is-grey is-inverted is-border is-square" @click="pcPurgeDate = null">
                    <i class="fal fa-times"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-2 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <span class="label is-margin-bottom-xxsmall">Étape Validée</span>
                <input id="pc_purge_validated" type="checkbox" name="pc_purge_validated"
                      class="switch is-success is-rounded is-medium"
                      v-model="privateProgram.pc_purge_validated">
                <label for="pc_purge_validated"></label>
              </div>
            </div>
            <div class="column is-4 is-padding-left is-padding-right is-padding-top">
              <label class="label">GFA Obtenu</label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-square is-border is-min-width-0">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded has-icons-right">
                  <flat-pickr type="date" class="input is-radiusless" v-model="gfaObtenuDate"
                              :config="dateConfig"></flat-pickr>
                </div>
                <div class="control">
                  <a class="button is-grey is-inverted is-border is-square" @click="gfaObtenuDate = null">
                    <i class="fal fa-times"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-2 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <span class="label is-margin-bottom-xxsmall">Étape Validée</span>
                <input id="gfa_obtenu_validated" type="checkbox" name="gfa_obtenu_validated"
                      class="switch is-success is-rounded is-medium" v-model="privateProgram.gfa_obtenu_validated">
                <label for="gfa_obtenu_validated"></label>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Prévisionnel début des travaux</label>
              <div class="control columns">
                <div class="select is-fullwidth">
                  <select v-model="debutTravaux" data-type-cy="select"
                          data-value-cy="select_delivery">
                    <option :value="null">Trimestre</option>
                    <option v-for="(t, i) in trims" :value="i + 1" :key="i">{{t[i + 1]}}
                    </option>
                  </select>
                </div>
                <div class="select is-fullwidth is-margin-left">
                  <select v-model="debut_travaux" data-type-cy="select"
                          data-value-cy="select_delivery">
                    <option :value="null">Année</option>
                    <option v-for="year in years" :value="year" :key="year">{{year}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Prévisionnel fin des travaux</label>
              <div class="control columns">
                <div class="select is-fullwidth">
                  <select v-model="finTravaux" data-type-cy="select"
                          data-value-cy="select_delivery">
                    <option :value="null">Trimestre</option>
                    <option v-for="(t, i) in trims" :value="i + 1" :key="i">{{t[i + 1]}}
                    </option>
                  </select>
                </div>
                <div class="select is-fullwidth is-margin-left">
                  <select v-model="fin_travaux" data-type-cy="select"
                          data-value-cy="select_delivery">
                    <option :value="null">Année</option>
                    <option v-for="year in years" :value="year" :key="year">{{year}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        <!-- FIN TERRAIN LIGNE 5 -->
        </div>
        <!-- FIN TERRAIN PERMIS DE CONSTRUIRE -->

        <!-- DEBUT DONNEE PROMOTEUR -->
        <div class="is-padding-left is-border has-bg-white is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-min-height-50 is-flex">
          <div class="is-self-centered"><span class="is-uppercase is-size-5">Données Promoteur</span></div>
        </div>
        <!-- FIN DONNEE PROMOTEUR -->

        <!-- DEBUT INFOS PROMOTEUR -->
        <div class="columns is-multiline is-padding-bottom has-bg-white">
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Nom de la société'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.promoteur_info.company_name" data-type-cy="text" data-value-cy="input_company_name"></r-label>
                <div class="control">
                  <v-input id="company_name" name="company_name" @input="val => privateProgram.promoteur_info.company_name = val" 
                          :model="privateProgram.promoteur_info.company_name"
                           v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val" classes="input"
                           data-vv-as="Nom de la société" data-type-cy="input" data-value-cy="input_company_name">
                  </v-input>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-12 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <!-- <r-label :label="'Aménagements prévus (séparé par une virgule)'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.planned_developments" data-type-cy="text" data-value-cy="input_planned_developments_label"></r-label> -->
                <div class="control">
                  <wysiwyg-editor :model="privateProgram.promoteur_info.reservant" :submited='isSubmited'
                                  :placeholder="`XXXXX au capital de XXXXX ${currency}, dont le siège social esty situé XXXXX — XXXXX XXXXX, immatriculé au RCS de XXXXX sous le n° XXXXX dûment représentée aux présentes par la XXXXX au capital de XXXXX dont le siège social est XXXXX — XXXXX XXXXX, immatriculé au RCS de XXXXX sous le n° XXXXX, elle même representé par son gérant XXXXX.`"
                                  :class="{'editr--hide-toolbar':!displayToolbar}" :light-program='true' :light='true'
                                  @change="val => privateProgram.promoteur_info.reservant = val"
                                  class="editr--bottom-toolbar editr--height-large content has-bg-white" />
                </div>
              </div>
            </div>
          </div>
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Nom du gérant/représentant de la société'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.promoteur_info.rep_last_name" data-type-cy="text" data-value-cy="input_rep_last_name_label"></r-label>
                <div class="control">
                  <v-input id="rep_last_name" name="rep_last_name" @input="val => privateProgram.promoteur_info.rep_last_name = val" 
                          :model="privateProgram.promoteur_info.rep_last_name"
                           v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val" classes="input"
                           data-vv-as="Nom du gérant/représentant de la société" data-type-cy="input" data-value-cy="input_rep_last_name">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Prénom du gérant/représentant de la société'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.promoteur_info.rep_first_name" data-type-cy="text" data-value-cy="input_rep_first_name_label"></r-label>
                <div class="control">
                  <v-input id="rep_first_name" name="rep_first_name" @input="val => privateProgram.promoteur_info.rep_first_name = val" 
                          :model="privateProgram.promoteur_info.rep_first_name"
                           v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val" classes="input"
                           data-vv-as="Prénom du gérant/représentant de la société" data-type-cy="input" data-value-cy="input_rep_first_name">
                  </v-input>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <r-label :label="'Téléphone de correspondance'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.promoteur_info.rep_phone"></r-label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i class="fas fa-mobile-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <v-input id="rep_phone" name="rep_phone" @input="val => privateProgram.promoteur_info.rep_phone = val" :model="privateProgram.promoteur_info.rep_phone"
                      v-validate="''" :errors-bag="errors" data-vv-value-path="val"
                      data-vv-as="Téléphone" v-mask="$configs.COUNTRY === 'FRA' ? '## ## ## ## ##' : '####################'">
                    </v-input>
                </div>
              </div>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <r-label :label="'Email de correspondance'" :is-required="hasCheck" :redCheck='hasCheck' :value="privateProgram.promoteur_info.rep_email" data-type-cy="text" data-value-cy="input_rep_email_label"></r-label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i class="fas fa-envelope"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <v-input id="privateProgram.promoteur_info.rep_email" name="privateProgram.promoteur_info.rep_email" @input="val => privateProgram.promoteur_info.rep_email = val"
                            :model="privateProgram.promoteur_info.rep_email" v-validate="'email'" :errors-bag="errors" data-vv-value-path="val"
                            data-vv-as="Email" data-type-cy="input" data-value-cy="input_rep_email">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <gmap-input :source="addressRep" :is-required="hasCheck" :redCheck='hasCheck'
                             label="Adresse de correspondance "
                             @submit="val => updateAddressRep(val, 'addressRep')" data-type-cy="gmap" data-value-cy="rep_address"></gmap-input>
              </div>
            </div>
          </div>
        </div>
        <!-- FIN INFOS PROMOTEUR -->

        <!-- DEBUT DONNEE NOTAIRE -->
        <div class="is-padding-left is-border has-bg-white is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-min-height-50 is-flex">
          <div class="is-self-centered"><span class="is-uppercase is-size-5">Notaire de l'opération</span></div>
        </div>
        <!-- FIN DONNEE NOTAIRE -->

        <!-- DEBUT INFO NOTAIRE -->
        <div class="columns has-bg-white is-multiline is-padding-bottom">
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Nom du notaire'" :is-required="hasCheck" :redCheck='hasCheck' :value="notary.name" data-type-cy="text" data-value-cy="input_notary.name_label"></r-label>
                <div class="control">
                  <v-input id="notary.name" name="notary.name" @input="val => notary.name = val" 
                          :model="notary.name"
                           v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val" classes="input"
                           data-vv-as="Nom du notaire" data-type-cy="input" data-value-cy="notary.name">
                  </v-input>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <r-label :label="'Téléphone du notaire'" :is-required="hasCheck" :redCheck='hasCheck' :value="notary.phone" data-type-cy="text" data-value-cy="input_notaryPhone_label"></r-label>
              <div class="field has-addons">
                <div class="columns is-gapless column is-12 is-paddingless">
                  <p class="control">
                    <a class="button is-square is-static is-border"><i class="fas fa-phone has-text-grey"></i></a>
                  </p>
                  <div class="control column">
                     <v-input id="notary_phone" name="notary_phone" @input="val => notary.phone = val" :model="notary.phone"
                      v-validate="''" :errors-bag="errors" data-vv-value-path="val"
                      data-vv-as="Téléphone" v-mask="$configs.COUNTRY === 'FRA' ? '## ## ## ## ##' : '####################'">
                    </v-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <r-label :label="'Email'" :value="notary.email" :is-required="hasCheck" :redCheck='hasCheck'></r-label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i class="fas fa-envelope"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <v-input id="email" name="email" @input="val => notary.email = val" :model="notary.email" class=""
                      v-validate="'email'" :errors-bag="errors" data-vv-value-path="val"
                      data-vv-as="Email">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <gmap-input :source="addressNotaire" :is-required="hasCheck" :redCheck='hasCheck'
                             label="Adresse de correspondance "
                             @submit="val => updateAddressNotaire(val, 'addressNotaire')" data-type-cy="gmap" data-value-cy="notaire_adress"></gmap-input>
              </div>
            </div>
          </div>
        </div>
        <!-- FIN INFO NOTAIRE -->
      </div>
      <!-------------------------------------------- FIN ADMINISTRATIF ----------------------------------------------->

      <!-------------------------------------------- DEBUT FICHE PROGRAMME ----------------------------------------------->
      <div v-show="panel === 'FICHE_PROGRAMME'">
        <!-- DEBUT MENU FICHE PROGRAMME -->
         <div class="tabs is-separatedUnderlined has-bg-white is-fullwidth is-marginless">
          <ul class="has-text-weight-medium">
            <li :class="{'is-active':panelFicheProgram === 'FICHE_DESCRIPTIVE'}">
              <a @click="panelFicheProgram = 'FICHE_DESCRIPTIVE'" data-type-cy="link" data-value-cy="fiche_descritpive">Fiche descriptive</a>
            </li>
            <li :class="{'is-active':panelFicheProgram === 'PARAMETRE'}">
              <a @click="panelFicheProgram = 'PARAMETRE'" data-type-cy="link"
                  data-value-cy="parametre_affichage">Paramètres d'affichage</a>
            </li>
          </ul>
        </div>
        <!-- FIN MENU FICHE PROGRAMME -->
        <!-- DEBUT ONGLET FICHE DESCRIPTIVE -->
        <div v-show="panelFicheProgram === 'FICHE_DESCRIPTIVE'">
          <!-- DEBUT LIGNE 1 -->
          <div class="column is-12 is-padding has-bg-grey2 is-border">
            <div class="field">
              <label class="label" data-type-cy="text" data-value-cy="input_rem_prog_label">Taux de commercialisation
                <span class="is-size-3 is-margin-left-xsmall"
                      v-helper.right.large="'1caCDpdd7eSkE08w4884Ec'">
                  <i class="fas fa-question-circle fa-xs has-text-grey"></i>
                </span>
              </label>
              <div class="columns is-gapless">
                <div class="column is-2">
                  <div class="field has-addons">
                    <div class="control is-expanded">
                      <input type="number" name="remuneration" v-model.number="privateProgram.remuneration"
                              step=".01" max="100"
                              class="input" data-type-cy="input" data-value-cy="input_rem_prog">
                    </div>
                    <div class="control">
                        <a class="button is-square is-static is-border is-min-width-0">
                            <span class="icon"><i class="fas fa-percentage"></i></span>
                        </a>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="notification is-warning is-size-6 is-padding-small is-border is-border--warning">
                    Le taux de commercialisation n'est visible que par les administrateurs, les managers et les
                    vendeurs internes
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- FIN LIGNE 1 -->

          <!-- DEBUT LIGNE 2 -->
          <div class="columns is-gapless is-12 is-border is-padding">
            <div class="column is-4 is-3-fullhd is-padding-right" v-if="isAdmin">
              <div class="field">
                <label class="label is-margin-bottom-large" data-type-cy="text" data-value-cy="switch_optionable_label">Paramétres des options</label>
                <p class="control">
                  <input id="is_optionable" type="checkbox" name="is_optionable" v-model="isOptionable"
                          class="switch is-success is-rounded is-medium" data-type-cy="switch"
                          data-value-cy="switch_optionable">
                  <label for="is_optionable" data-type-cy="text" data-value-cy="switch_optionable_value" class="is-uppercase">
                    <span v-if="isOptionable" class="is-size-6 is-margin-top-xxsmall">Programme optionnable</span>
                    <span v-else class="is-size-6 is-margin-top-xxsmall">Programme non optionnable</span>
                    &nbsp;
                  </label>
                </p>
              </div>
            </div>
            <div class="column is-4 is-3-fullhd is-padding-right" v-if="isAdmin">
              <div class="field">
                <label class="label is-margin-bottom-large" data-type-cy="text" data-value-cy="switch_optionable_label">&nbsp;</label>
                <p class="control">
                  <input id="autoValidation" type="checkbox" name="autoValidation" v-model="autoValidation"
                          class="switch is-success is-rounded is-medium" data-type-cy="switch"
                          data-value-cy="switch_auto_valid">
                  <label for="autoValidation" data-type-cy="text" data-value-cy="switch_auto_valid_value" class="is-uppercase">
                    <span v-if="autoValidation" class="is-size-6 is-margin-top-xxsmall">Validation automatique des options</span>
                    <span v-else class="is-size-6 is-margin-top-xxsmall">Validation manuel des options</span>
                  </label>
                </p>
              </div>
            </div>
            <div class="column is-4 is-3-fullhd">
              <div class="field">
                <r-label class="is-margin-bottom-small" :label="'Durée de validité des Options (h)'" :value="privateProgram.option_period" data-type-cy="text" data-value-cy="input_option_time_label"></r-label>
                <div class="columns is-gapless">
                  <div class="field has-addons" style="width: 100%">
                    <div class="control">
                      <a class="button is-square is-static is-border is-min-width-0">
                        <span class="icon"><i class="far fa-clock"></i></span>
                      </a>
                    </div>
                    <div class="control is-expanded">
                      <v-input id="option_period" name="option_period" :model="privateProgram.option_period" inputType="number"
                        data-vv-as="Durée des Options (h)" step="1" :min="1" :max="100" @input="val => privateProgram.option_period = val"
                        v-validate="'required'" :errors-bag="errors" data-vv-value-path="val" :number="true"
                        data-type-cy="input" data-value-cy="input_option_time_label">
                      </v-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- FIN LIGNE 2 -->

          <!-- DEBUT DESCRIPTION PROGRAMME -->
          <div class="is-padding-left has-bg-white is-border-right is-border-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-min-height-50 is-flex">
            <div class="is-self-centered"><span class="is-uppercase is-size-5">Description du Programme</span></div>
          </div>
          <!-- FIN DESCRIPTION PROGRAMME -->
          
          <!-- DEBUT DISPOSITIF FISCAL -->
          <div class="columns is-multiline is-border has-bg-white">
            <div class="column is-12 is-padding">
              <label class="label is-padding-bottom-xsmall" data-type-cy="text" data-value-cy="disp_fisc_label">Dispositifs Fiscaux<i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i></label>
              <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                <div class="column is-4" v-for="t in taxDispositifsList" :key="t.value" data-type-cy="checkbox" data-value-cy="disp_fisc_checkbox">
                  <input v-model="selectedTaxDispositifs" :value="t.value"
                        :name="t.value" :id="t.value" type="checkbox" class="checkradiocase is-fullwidth">
                  <label :for="t.value">{{t.label}}</label>
                </div>
              </div>
            </div>
            <div class="column is-12 is-padding">
              <label class="label is-padding-bottom-xsmall" data-type-cy="text" data-value-cy="certif_label">Certifications<i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i></label>
              <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                <div class="column is-4" v-for="t in programCertificationsList" :key="t.value" data-type-cy="checkbox" data-value-cy="certif_checkbox">
                  <input v-model="selectedCertifications" :value="t.value"
                        :name="t.value" :id="t.value" type="checkbox" class="checkradiocase is-fullwidth">
                  <label :for="t.value">{{t.label}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- FIN DISPOSITIF FISCAL -->

          <!-- DEBUT DESCRITPION TEXTE  -->
          <div class="columns is-multiline has-bg-light is-border-left is-border-right is-border-bottom">
            <div class="column is-12 is-paddingless-bottom">
              <div class="title is-5" data-type-cy="text" data-value-cy="desc_title">
                <b class="is-uppercase">Description</b>
              </div>
            </div>
            <div class="is-border-bottom is-margin-top has-bg-light is-12 column is-paddingless"
                v-for="(d, i) in descriptions" :key="i" data-type-cy="description_list" data-value-cy="description_list">
              <div class="column is-paddingless-top">
                <label class="label" data-type-cy="text" :data-value-cy="'input_desc_title_label' + i">
                  Titre de la description * <i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i>
                  <div class="has-text-right">
                    <a @click.prevent.stop="descriptions.splice(i, 1)"
                      class="button is-square is-border is-radiusless is-margin-neg-top"
                      data-type-cy="button" :data-value-cy="'btn_desc_delete' + i">
                      <i class="fal fa-trash-alt"></i>
                    </a>
                  </div>
                </label>
                <div class="field">
                  <div class="control">
                    <v-input v-if="(d.text === null || d.text === '' )" :id="'descTitle' + i" :name="'descTitle' + i" @input="val => d.title = val" :model="d.title"
                            data-vv-as="Titre de la description" placeholder="Saisissez un titre"
                            v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val"
                            data-type-cy="input" :data-value-cy="'input_desc_title' + i">
                    </v-input>
                    <v-input v-else-if="(d.text !== null && d.text !== '' ) && (d.title !== null && d.title !== '')" :id="'descTitle' + i" :name="'descTitle' + i" @input="val => d.title = val" :model="d.title"
                            data-vv-as="Titre de la description" placeholder="Saisissez un titre"
                            v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                            data-type-cy="input" :data-value-cy="'input_desc_title' + i">
                    </v-input>
                    <v-input v-else-if="(d.text !== null && d.text !== '' )" :id="'descTitle' + i" :name="'descTitle' + i" @input="val => d.title = val" :model="d.title"
                            data-vv-as="Titre de la description" placeholder="Saisissez un titre"
                            v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val" :provocatedError='true'
                            provocatedMessage="Le champ Titre de la description est requis."
                            data-type-cy="input" :data-value-cy="'input_desc_title' + i">
                    </v-input>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless-top">
                <label class="label" data-type-cy="text" data-value-cy="input_desc_label">Texte de la description * <i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i></label>
                <div class="field" @mouseover="displayToolbar = true" @mouseleave="displayToolbar = false">
                  <div class="control">
                    <wysiwyg-editor :model="d.text" placeholder="" :id="'descText' + i" :name="'descText' + i"
                                    @change="val => d.text = val" :submited='isSubmited'
                                    :class="{'editr--hide-toolbar':!displayToolbar}"
                                    class="editr--bottom-toolbar editr--height-medium content has-bg-white"
                                    data-type-cy="wysiwyg-editor" :data-value-cy="'input_desc' + i"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12 has-text-right">
              <a @click="addDescriptions"
                class="button is-white is-border is-rounded is-transform-none is-padding-right-large is-padding-left-large"
                data-type-cy="button" data-value-cy="btn_add_desc">
                &nbsp;<span class="icon is-small has-text-grey"><i class="fas fa-plus-square"></i></span><span>Ajouter une description</span></a>
            </div>
          </div>
          <div class="columns is-multiline has-bg-white is-border-left is-border-right is-border-bottom">
            <div class="column is-12 is-paddingless-bottom">
              <div class="title is-5">
                <b class="is-uppercase">Photo, Image, Illustration</b>
                <span class="is-padding-left-xsmall" v-helper.bottom="'48pvPnXWhfMnF10pIqZ4tj'">
                  <i class="fal fa-info-circle"></i>
                </span>
              </div>
            </div>
            <div class="column is-12 is-border-bottom">
              <div>
                <label class="label">Téléchargez des images</label>
                <upload-file @upload="uploadImage"
                            :custom-id="'pictures'"
                            @deleteDocuments="deleteDocuments"
                            :documents="pictures"
                            :is-image="true"></upload-file>
              </div>
            </div>
            <div class="column is-12 is-paddingless-bottom">
              <div class="title is-5">
                <b class="is-uppercase">Vidéo</b>
              </div>
            </div>
            <div class="column columns is-multiline is-paddingless-left is-paddingless-bottom"
                v-if="videos && videos.length">
              <div class="column columns is-12 is-paddingless-bottom is-paddingless-top is-paddingless-right" v-for="(v, i) in videos"
                  :key="i">
                <div class="column is-paddingless-left is-paddingless-top is-paddingless-bottom is-5">
                  <div class="field">
                    <label class="label">Ajouter une vidéo
                      <span class="is-size-3 is-margin-left-xsmall" v-helper.right="'7ALurQLfhueqeoIemW440O'">
                        <i class="fas fa-question-circle fa-xs has-text-grey"></i>
                      </span>
                    </label>
                    <div class="control">
                      <div class="select is-fullwidth">
                        <select class="" v-model="v.provider">
                          <option :value="null">Sélectionner un fournisseur</option>
                          <option v-for="provider in videoProvidersList" :value="provider.value" :key="provider.label">
                            {{provider.label}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-paddingless is-7">
                  <div class="field">
                    <label class="label">ID de la vidéo
                      <span class="is-size-3 is-margin-left-xsmall" v-helper.right="'5D82usoormWikEgASSOqog'">
                        <i class="fas fa-question-circle fa-xs has-text-grey"></i>
                      </span>
                    </label>
                    <div class="field has-addons">
                      <div class="control is-expanded">
                        <v-input :id="'videoId' + i" :name="'videoId' + i" @input="val => v.video_id = val"
                                :model="v.video_id"
                                data-vv-as="ID de la vidéo"
                                v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val">
                        </v-input>
                      </div>
                      <div class="control">
                        <a @click.prevent.stop="videos.splice(i, 1)"
                          class="button is-square is-grey is-inverted is-border">
                          <i class="fal fa-trash-alt"></i>
                        </a>
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12 has-text-right">
              <a @click="addVideo"
                class="button is-white is-border is-rounded is-transform-none is-padding-right-large is-padding-left-large">
                &nbsp;<span class="icon is-small has-text-grey"><i class="fas fa-plus-square"></i></span><span>Ajouter une vidéo</span></a>
            </div>
          </div>
          <!-- FIN DESCRIPTION TEXTE -->
        </div>
        <!-- FIN ONGLET FICHE DESCRIPTIVE -->

        <!-- DEBUT ONGLET PARAMETRE -->
        <div v-show="panelFicheProgram === 'PARAMETRE'">
          <div class="columns is-multiline has-bg-white">
            <div class="column is-12 is-padding" v-if="isAdmin">
              <label class="label is-padding-bottom-xsmall" data-type-cy="text" data-value-cy="program_status_label">État du programme</label>
              <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                <div class="column is-3" v-for="s in workflowStatusList" :key="'status-'+s.value" data-type-cy="checkbox" data-value-cy="program_status_checkbox">
                  <input v-model="selectedStatusData" :value="s.value"
                        :name="'selectedStatusData'" :id="'status-'+s.value" type="radio"
                        class="checkradiocase is-fullwidth">
                  <label :for="'status-'+s.value">{{s.label}}</label>
                </div>
              </div>
              <div class="is-paddingless">
                <div class="notification is-warning is-padding-top-small is-padding-bottom-small is-size-6"
                    v-if="selectedStatusData && statusHelperText" v-html="statusHelperText">
                </div>
              </div>
            </div>
            <div class="column is-12 is-padding">
              <label class="label is-padding-bottom-xsmall" data-type-cy="text" data-value-cy="program_step_label">État d'avancement</label>
              <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                <div class="column is-3" v-for="p in programStepProgressList" :key="'step-'+p.value" v-if="!p.message" data-type-cy="checkbox" data-value-cy="program_step_checkbox">
                  <input v-model="privateProgram.progress_step" :value="p.value"
                        :name="'progress_step'" :id="'step-'+p.value" type="radio" class="checkradiocase is-fullwidth">
                  <label :for="'step-'+p.value" :class="{'has-bg-info' : privateProgram.progress_step === p.value}">{{p.label}}</label>
                </div>
              </div>
            </div>
            <div class="column is-5 is-padding">
              <div class="field">
                <label for="" class="label">Tags (30 caractères max, 4 tags max)
                  <span style="position: relative;" v-helper.right="'2P2agwmxC08668qCK4WUSA'">
                    <i class="fal fa-question-circle has-text-grey is-size-6 is-margin-left-xsmall"></i>
                  </span>
                </label>
                <div class="control">
                  <tag-input @tagChange="tagChange" :tag="privateProgram.tags"
                            v-model="privateProgram.tags"
                            :max-tags="4" :max="30"
                            :placeholder="'Appuyez sur Entrée pour valider'">
                  </tag-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- FIN ONGLET PARAMETRE -->
      </div>
      <!-------------------------------------------- FIN FICHE PROGRAMME ----------------------------------------------->

      <!-------------------------------------------- DEBUT DOCUMENTATION ----------------------------------------------->
      <div v-show="panel === 'DOCUMENTATION'">
        <program-document-tab :source="privateProgram" :select-panel="'DOCS'" @submitDocument="submitDocument"></program-document-tab>
      </div>
      <!-------------------------------------------- DEBUT APPEL_DE_FOND ----------------------------------------------->
      <div v-show="panel === 'APPEL_DE_FOND'">
        <div class="has-bg-white">
          <div class="is-padding">
            <div class="title is-5">
              <b class="is-uppercase">Appel de fonds</b>
            </div>
          </div>
          <div class="has-bg-annonce columns is-vcentered" v-if="errorStepsAmount">
            <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
              <span class="icon has-text-white"><i class="fas fa-engine-warning fa-lg"></i></span>
            </div>
            <div class="column is-paddingless-left is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-white is-italic is-size-6">
                <span>Le total des appels de fonds ne peut excéder 100%</span>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-paddingless-top is-paddingless-bottom is-8">Étapes</div>
            <!-- <div class="column is-paddingless-top is-paddingless-bottom is-3">Réception situation travaux</div> -->
            <div class="column is-paddingless-left is-paddingless-top is-paddingless-bottom is-4"></div>
          </div>
          <div v-dragula="steps" drake="one">
            <div class="columns is-vcentered is-gapless is-padding-left is-padding-right" v-for="(step, i) in steps" :key="step.uuid" :class="{'draggable':!step.is_valid}">
              <div class="column is-margin-top-xsmall is-8">
                <div class="field has-addons">
                  <div class="control is-narrow">
                    <a class="button is-border is-square is-min-width-0" style="cursor: move;">
                      <span class="icon"><i class="fas fa-arrows"></i></span>
                    </a>
                  </div>
                  <div class="control is-expanded">
                    <v-input :name="step.uuid + 'name'" @input="val => step.name = val"
                            @change="hasChangeADF = true" :model="step.name"
                            v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                            classes="" :disabled="step.is_valid"
                            data-vv-as="Nom">
                    </v-input>
                  </div>
                  <div class="control is-2">
                    <v-input :name="step.uuid + 'progress'" @input="val => step.progress = val"
                            @change="hasChangeADF = true"
                            :model="step.progress"
                            v-validate="'required|decimal:2|min_value:0|max_value:100'" :errors-bag="errors"
                            data-vv-value-path="val"
                            classes="" :disabled="step.is_valid"
                            data-vv-as="Avancement de l'étape">
                    </v-input>
                  </div>
                  <div class="control is-narrow">
                    <a class="button is-static is-border is-square is-min-width-0">
                      <span class="icon"><i class="fas fa-percentage"></i></span>
                    </a>
                  </div>
                  <div class="control is-narrow">
                    <a class="button is-square is-grey is-inverted is-border"
                       :disabled="step.is_valid"
                       @click="!step.is_valid ? removeStep(step) : null">
                      <span class="icon"><i class="fal fa-trash-alt"></i></span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-margin-top-xsmall is-4 is-padding-left">
                <input :id="step.uuid + 'step_is_valid'" type="checkbox" :name="step.uuid + 'step_is_valid'"
                       class="switch is-success is-medium" v-model="step.is_valid" @input="hasChangeADF = true">
                <label :for="step.uuid + 'step_is_valid'"><span class="is-size-5">{{step.is_valid ? 'Etape validée': 'Valider étape'}}</span></label>
              </div>
            </div>
          </div>
          <div class="field is-grouped is-padding">
            <div class="control">
              <a class="button is-small is-border is-rounded is-transform-none" @click="addStep">&nbsp;
                <span class="icon is-small has-text-grey"><i class="fas fa-plus-square"></i></span> <span>Ajouter une étape d'appel de fond</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-------------------------------------------- FIN APPEL_DE_FOND ----------------------------------------------->
      <div class="formActionsSticky is-bottom is-margin-top">
        <div class=" columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
          <div class="column is-4 is-3-widescreen is-margin-right-small">
            <a @click="$router.goBack(route)" class="button is-light is-uppercase is-fullwidth"
               data-type-cy="button" data-value-cy="form_cancel">
              <span>Annuler</span>
            </a>
          </div>
          <div class="column is-4 is-3-widescreen is-margin-left-small">
            <button class="button is-success is-uppercase is-fullwidth has-text-white"
                    :disabled="!canSubmit || loading" @click="submit(true)" :class="{'is-loading':loading}"
                    data-type-cy="button" data-value-cy="form_validation">
              <span v-if="!loading">Valider</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import UploadFile from '@/components/utils/UploadFile'
  import { isNil, isEmpty, compact, isPlainObject } from 'lodash'
  import VueScrollTo from 'vue-scrollto'
  import { DefaultValues } from '../../mixins'
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment'
  import { moveInArray } from '../../utils'
  import ProgramDocumentTab from './ProgramDocumentTab'

  const showdown = require('showdown')

  const emptyProgram = {
    name: null,
    tax_dispositifs: [],
    status: 'draft',
    promoteur: null,
    location: {},
    reference_cadrastrale: null,
    surface_terrain: null,
    surface_plancher: null,
    num_pc: null,
    construction_licence: null,
    construction_licence_author: null,
    construction_licence_date: null,
    total_buildings: null,
    total_lots: null,
    total_parking: null,
    planned_developments: null,
    progress_step: null,
    auto_validation: false,
    remuneration: null,
    full_date_actabilite: null,
    full_date_livraison: null,
    date_actabilite: null,
    date_livraison: null,
    debut_travaux: null,
    fin_travaux: null,
    is_optionable: true,
    description: [],
    pictures: [],
    promoteur_info: {},
    documents: [],
    option_period: 48,
    livraison_validated: false,
    actabilite_validated: false,
    gfa_obtenu_validated: false,
    pc_purge_validated: false,
    pc_depose_validated: false,
    gfa_obtenu_date: null,
    pc_purge_date: null,
    pc_depose_date: null
  }
  const emptyDescriptions = {
    title: null,
    text: null
  }
  const emptyNotary = {
    name: null,
    address: null,
    email: null,
    phone: null
  }

  const emptyVideo = {
    provider: null,
    video_id: null
  }

  export default {
    name: 'ProgramForm',
    data () {
      return {
        pictures: [],
        hasChangeADF: false,
        panelFicheProgram: 'FICHE_DESCRIPTIVE',
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y'
        },
        panelDocument: 'DOCS',
        isSubmited: false,
        hasCheck: false,
        pcPurgeDate: null,
        pcDeposeDate: null,
        gfaObtenuDate: null,
        fullDateActabilite: null,
        fullDateLivraison: null,
        location: {},
        privateProgram: {},
        notary: {},
        notaryAddress: null,
        promoteurs: [],
        promoteurChange: '',
        selectedTaxDispositifs: [],
        selectedCertifications: [],
        selectedStatusData: null,
        statusHelperText: null,
        validOptionHelperTitle: null,
        validOptionHelperText: null,
        autoValidation: false,
        forceLivrable: false,
        isOptionable: false,
        forceActabilite: false,
        c: true,
        descriptions: [],
        dateConfig: {
          dateFormat: 'd/m/Y'
        },
        completeAddress: false,
        address: {
          line1: null,
          city: null,
          zip_code: null,
          country: null
        },
        addressCompany: {
          line1: null,
          city: null,
          zip_code: null,
          country: null
        },
        addressRep: {
          line1: null,
          city: null,
          zip_code: null,
          country: null
        },
        addressNotaire: {
          line1: null,
          city: null,
          zip_code: null,
          country: null
        },
        route: this.$route,
        panel: 'ADMINISTRATIF',
        isNew: true,
        videos: [],
        displayToolbar: false,
        livraisonTrimestre: null,
        debutTravaux: null,
        debut_travaux: null,
        finTravaux: null,
        fin_travaux: null,
        livraison: null,
        actabiliteTrimestre: null,
        actabilite: null,
        trims: [{1: '1er trimestre'}, {2: '2eme trimestre'}, {3: '3eme trimestre'}, {4: '4eme trimestre'}]
      }
    },
    props: {
      program: {
        required: false
      },
      loading: {
        required: false,
        default: false
      },
      selectPanel: {
        type: String,
        default: 'ADMINISTRATIF'
      }
    },
    mixins: [DefaultValues],
    components: {UploadFile, ProgramDocumentTab},
    watch: {
      promoteurChange (value) {
        this.$set(this.privateProgram, 'promoteur', value)
        this.$set(this.privateProgram, 'promoteur_name', value.name || value)
      },
      selectedStatusData () {
        this.updateHelperText()
      },
      selectPanel (v) {
        if (v) {
          this.panel = v
        }
      }
    },
    computed: {
      ...mapState({
        promoteursList: 'promoteurs',
        configs: 'configs'
      }),
      ...mapGetters(['isExternal', 'isSeller', 'isAdmin', 'isManager', 'isDistributeurMode', 'isPromoteurMode']),
      steps () {
        return this.privateProgram.construction_steps
      },
      actabilityTerm () {
        if (!this.configs) return
        let term = {
          FRA: 'Actabilité',
          MAR: 'Titre foncier'
        }
        return term[this.configs.COUNTRY]
      },
      currency () {
        return this.$currency
      },
      statusHelperId () {
        if (!this.selectedStatusData) {
          return null
        }
        let IDS = {
          archived: 'zLynaCi2aWaUMuGIcwaqg',
          draft: '1EkcUUvtyI6oaAmmq6UWok',
          available: '4ncpu5K3ks66cO8wmo8EYC',
          private: '7EaDxyrfNY0MgcIo66o0Sq'
        }
        return IDS[this.selectedStatusData]
      },
      canSubmit () {
        return (this.privateProgram.promoteur || this.isPromoteurMode) && !this.errorStepsAmount && this.canSubmitDescription
      },
      canSubmitDescription () {
        let verification = []
        this.descriptions.forEach((value, index) => {
          if ((value.text !== null && value.text !== '') && (value.title === null || value.title === '')) verification.push('false')
        })
        if (isEmpty(verification)) {
          return true
        } else {
          return false
        }
      },
      years () {
        let years = []
        let currentYear = moment().format('YYYY')
        for (let i = Number(currentYear) - 5; i < Number(currentYear) + 10; i++) years.push(i)
        return years
      },
      extandedTrimestrialsChoices () {
        if (this.trimestrialsChoices && this.trimestrialsChoices.length) {
          let currentYear = moment().format('YYYY')
          let trims = this.trimestrialsChoices.slice()
          let currentQuarter = moment().format('Q')
          let currentTrim = [parseInt(`${currentYear}${currentQuarter}`), `${currentQuarter}T ${currentYear}`]
          let passedTrim = [parseInt(`${currentYear}${currentQuarter - 1}`), `${currentQuarter - 1}T ${currentYear}`]
          if (currentQuarter === '1') {
            passedTrim = [parseInt(`${currentYear - 1}4`), `4T ${currentYear - 1}`]
          }
          trims.unshift(passedTrim, currentTrim)
          return trims
        }
      },
      documents () {
        if (this.privateProgram && this.privateProgram.documents && this.privateProgram.documents) {
          return this.privateProgram.documents.slice()
        } else return []
      },
      errorStepsAmount () {
        let amount = 0
        if (this.steps && this.steps.length) {
          amount = this.steps.reduce((a, b) => {
            if (b.progress) return a + Number(b.progress)
            else return a
          }, 0)
        }
        return amount > 100
      },
      fromFlux () {
        if (this.program && this.program.from_flux) {
          return this.program.from_flux
        } else {
          return false
        }
      },
      checkProgram () {
        if (this.hasCheck) {
          if (!this.privateProgram) return
          return (this.privateProgram.total_lots !== null && this.privateProgram.total_lots !== '') &&
          (this.privateProgram.reference_cadrastrale !== null && this.privateProgram.reference_cadrastrale !== '') &&
          (this.privateProgram.surface_terrain !== null && this.privateProgram.surface_terrain !== '') &&
          (this.privateProgram.surface_plancher !== null && this.privateProgram.surface_plancher !== '') &&
          (this.privateProgram.num_pc !== null && this.privateProgram.num_pc !== '') &&
          (this.privateProgram.total_parking !== null && this.privateProgram.total_parking !== '') &&
          (this.privateProgram.planned_developments !== null && this.privateProgram.planned_developments !== '') &&
          (this.privateProgram.construction_licence_author !== null && this.privateProgram.construction_licence_author !== '') &&
          (this.privateProgram.construction_licence_date !== null && this.privateProgram.construction_licence_date !== '') &&
          (this.privateProgram.total_buildings !== null && this.privateProgram.total_buildings !== '') &&
          (this.privateProgram.promoteur_info.rep_first_name !== null && this.privateProgram.promoteur_info.rep_first_name !== '') &&
          (this.privateProgram.promoteur_info.rep_last_name !== null && this.privateProgram.promoteur_info.rep_last_name !== '') &&
          (this.privateProgram.promoteur_info.rep_email !== null && this.privateProgram.promoteur_info.rep_email !== '') &&
          (this.privateProgram.promoteur_info.rep_phone !== null && this.privateProgram.promoteur_info.rep_phone !== '') &&
          (this.privateProgram.promoteur_info.rep_address !== null && this.privateProgram.promoteur_info.rep_address !== '') &&
          (this.privateProgram.name !== null && this.privateProgram.name !== '') &&
          (this.privateProgram.promoteur_name !== null && this.privateProgram.promoteur_name !== '') &&
          (this.address.line1 !== null && this.address.line1 !== '') &&
          (this.address.city !== null && this.address.city !== '') &&
          (this.address.zip_code !== null && this.address.zip_code !== '') &&
          (this.privateProgram.ref !== null && this.privateProgram.ref !== '')
        } else {
          return (this.privateProgram.name !== null && this.privateProgram.name !== '') &&
          (this.privateProgram.promoteur_name !== null && this.privateProgram.promoteur_name !== '') &&
          (this.address.line1 !== null && this.address.line1 !== '') &&
          (this.address.city !== null && this.address.city !== '') &&
          (this.address.country !== null && this.address.country !== '') &&
          (this.address.zip_code !== null && this.address.zip_code !== '')
        }
      },
      otherDocuments () {
        if (this.privateProgram.documents && this.privateProgram.documents.length) {
          return compact(
            this.privateProgram.documents
              .filter(x => {
                if (!isNil(x) && x.filename) return !['Brochure du programme', 'Dossier de réservation'].includes(x.filename)
                else return true
              })
          )
        } else return []
      },
      brochure () {
        if (this.privateProgram.documents && this.privateProgram.documents.length) {
          return compact([
            this.privateProgram.documents
              .find(x => !isNil(x) && x.filename ? x.filename === 'Brochure du programme' : false)
          ])
        } else return []
      },
      reservation () {
        if (this.privateProgram.documents && this.privateProgram.documents.length) {
          return compact([
            this.privateProgram.documents
              .find(x => !isNil(x) && x.filename ? x.filename === 'Dossier de réservation' : false)
          ])
        } else return []
      }
    },
    methods: {
      submitDocument (documents, documentAdv) {
        this.privateProgram.documents = documents
        console.log(this.privateProgram.documents)
        this.privateProgram.adv_documents = documentAdv
      },
      goDown (step) {
        let steps = this.privateProgram.construction_steps.slice()
        let oldIndex = steps.findIndex(x => x.uuid === step.uuid)
        moveInArray(steps, oldIndex, oldIndex + 1)
        this.$set(this.privateProgram, 'construction_steps', steps)
      },
      goUp (step) {
        let steps = this.privateProgram.construction_steps.slice()
        let oldIndex = steps.findIndex(x => x.uuid === step.uuid)
        moveInArray(steps, oldIndex, oldIndex - 1)
        this.$set(this.privateProgram, 'construction_steps', steps)
      },
      removeStep (step) {
        this.hasChangeADF = true
        let currentPosition
        if (step.uuid) {
          currentPosition = this.privateProgram.construction_steps.findIndex(x => x.uuid === step.uuid)
        } else {
          currentPosition = this.privateProgram.construction_steps.findIndex(x => x.uuid === undefined)
        }
        this.privateProgram.construction_steps.splice(currentPosition, 1)
      },
      addStep () {
        let newStep = {
          name: 'Nouvelle étape...',
          progress: 0
        }
        this.hasChangeADF = true
        this.privateProgram.construction_steps.push(newStep)
        this.submit(false)
      },
      updateHelperText () {
        this.statusHelperText = null
        if (this.selectedStatusData && this.statusHelperId && this.$contentful) {
          this.$contentful.getEntry(this.statusHelperId)
            .then(entry => {
              let converter = new showdown.Converter()
              let text = entry.fields.text
              this.statusHelperText = converter.makeHtml(text)
            })
        }
      },
      submit (reload = true) {
        this.isSubmited = true
        if (!this.address.zip_code) {
          return this.$notify({type: 'is-danger', text: 'L\'adresse et le code postal sont requis.'})
        }
        if (this.privateProgram.ref === '') this.privateProgram.ref = null
        this.smallLoading = true
        this.privateProgram.tax_dispositifs = this.selectedTaxDispositifs
        this.privateProgram.certifications = this.selectedCertifications
        this.privateProgram.status = this.selectedStatusData
        this.privateProgram.auto_validation = this.autoValidation
        this.privateProgram.is_optionable = this.isOptionable
        this.privateProgram.pictures = this.pictures.slice()
        // this.privateProgram.documents = this.documents.slice()
        this.privateProgram.address = Object.assign({}, this.address)
        this.privateProgram.promoteur_info.company_address = Object.assign({}, this.addressCompany)
        this.privateProgram.promoteur_info.rep_address = Object.assign({}, this.addressRep)
        this.privateProgram.videos = this.videos.filter(x => !!x.video_id)
        this.privateProgram.descriptions = this.descriptions.filter(x => !!x.title)
        if (!isNil(this.location) && !isEmpty(this.location)) {
          this.privateProgram.location = Object.assign({}, this.location)
        }
        if (this.forceActabilite && (!this.privateProgram.full_date_actabilite ||
          (this.fullDateActabilite && moment(this.fullDateActabilite).format('YYYYMMDD') > moment().format('YYYYMMDD')))) {
          this.privateProgram.full_date_actabilite = moment().format('DD/MM/YYYY')
        }
        if (this.forceLivrable && (!this.privateProgram.full_date_livraison ||
          (this.fullDateLivraison && moment(this.fullDateLivraison).format('YYYYMMDD') > moment().format('YYYYMMDD')))) {
          this.privateProgram.full_date_livraison = moment().format('DD/MM/YYYY')
        }
        if (this.pcDeposeDate && this.pcDeposeDate !== '') {
          this.privateProgram.pc_depose_date = this.pcDeposeDate
        } else {
          this.privateProgram.pc_depose_date = null
        }
        if (this.pcPurgeDate && this.pcPurgeDate !== '') {
          this.privateProgram.pc_purge_date = this.pcPurgeDate
        } else {
          this.privateProgram.pc_purge_date = null
        }
        if (this.gfaObtenuDate && this.gfaObtenuDate !== '') {
          this.privateProgram.gfa_obtenu_date = this.gfaObtenuDate
        } else {
          this.privateProgram.gfa_obtenu_date = null
        }
        if (this.privateProgram.remuneration === '') this.privateProgram.remuneration = null
        if (this.privateProgram.total_buildings === '') this.privateProgram.total_buildings = null
        if (this.privateProgram.total_parking === '') this.privateProgram.total_parking = null
        if (this.privateProgram.total_lots === '') this.privateProgram.total_lots = null
        if (this.privateProgram.surface_plancher === '') this.privateProgram.surface_plancher = null
        // this.notary.address = this.notaryAddress
        this.privateProgram.debut_travaux = this.debut_travaux ? `${this.debut_travaux}${this.debutTravaux || '1'}` : null
        this.privateProgram.fin_travaux = this.fin_travaux ? `${this.fin_travaux}${this.finTravaux || '1'}` : null
        this.privateProgram.date_livraison = this.livraison ? `${this.livraison}${this.livraisonTrimestre || '1'}` : null
        this.privateProgram.date_actabilite = this.actabilite ? `${this.actabilite}${this.actabiliteTrimestre || '1'}` : null
        this.privateProgram.notary = Object.assign({}, this.notary)
        this.privateProgram.notary.address = Object.assign({}, this.addressNotaire)
        console.log(this.privateProgram.notary)
        this.validate((valid) => {
          if (valid) {
            this.$emit('submit', this.privateProgram, this.isNew, this.hasChangeADF, reload)
          } else {
            this.$notify({
              type: 'is-danger',
              text: 'Erreur Le formulaire est invalide.'
            })
          }
        })
      },
      updateAddress ({address, location}, val) {
        this.$set(this, val, address)
        if (!isNil(location) && val === 'address') {
          this.$set(this, 'location', location)
        }
      },
      updateAddressCompany ({address, location}, val) {
        this.$set(this, val, address)
        if (!isNil(location) && val === 'address') {
          this.$set(this.privateProgram, 'company_address', location)
        }
      },
      updateAddressRep ({address, location}, val) {
        this.$set(this, val, address)
        if (!isNil(location) && val === 'address') {
          this.$set(this.privateProgram, 'rep_address', location)
        }
      },
      updateAddressNotaire ({address, location}, val) {
        console.log(val)
        console.log(address)
        this.$set(this, val, address)
        if (!isNil(location) && val === 'addressNotaire') {
          this.$set(this.privateProgram.notary, 'address', address)
        }
        console.log(this.privateProgram.notary)
      },
      getPromoteurs (query) {
        this.$api.promoteurService.get({name: query}).then(res => {
          this.promoteurs = res.data.items
        })
      },
      inlineAddress (val) {
        if (isPlainObject(val)) {
          return compact([val.line1, val.city, val.country]).join(', ')
        } else return val
      },
      clearAll () {
        this.promoteurs = []
      },
      uploadImage (e) {
        if (e.cropped) this.pictures.splice(e.croppedIndex, 1, e[0])
        else e.map(el => this.pictures.push(el))
      },
      deleteDocuments (document) {
        let idx = this.pictures.findIndex(x => x.filename === document.filename)
        this.pictures.splice(idx, 1)
        this.privateProgram.pictures = this.pictures.slice()
      },
      tagChange (newTags) {
        this.$set(this.privateProgram, 'tags', newTags)
      },
      validate (cb) {
        this.$validator.validateAll().then((result) => {
          cb(result)
        })
      },
      addDescriptions () {
        this.descriptions.push(Object.assign({}, emptyDescriptions))
      },
      initDocuments (program) {
        if (!Array.isArray(program.pictures)) program.pictures = []
        if (!Array.isArray(program.documents)) program.documents = []
        if (program.pc_depose_date) {
          this.pcDeposeDate = new Date(program.pc_depose_date)
        }
        if (program.pc_purge_date) {
          this.pcPurgeDate = new Date(program.pc_purge_date)
        }
        if (program.gfa_obtenu_date) {
          this.gfaObtenuDate = new Date(program.gfa_obtenu_date)
        }
        if (program.full_date_actabilite) {
          this.fullDateActabilite = new Date(program.full_date_actabilite)
        }
        if (program.full_date_livraison) {
          this.fullDateLivraison = new Date(program.full_date_livraison)
        }
      },
      getValidOptionHelper () {
        if (this.$contentful) {
          this.$contentful.getEntry('DmPe3NRUvmCGOqc2wOGQ0').then(entry => {
            this.validOptionHelperTitle = entry.fields.title
            this.validOptionHelperText = entry.fields.text
          })
        }
      },
      addVideo () {
        this.videos.push(Object.assign({}, emptyVideo))
      }
      // validSteps (idx, val) {
      //   if (!val) {
      //     for (let i = 0; i <= idx; i++) {
      //       this.$set(this.privateProgram.construction_steps[i], 'is_valid', true)
      //     }
      //   }
      // }
    },
    mounted () {
      let options = {
        container: '#app',
        easing: 'ease-in',
        offset: -400
      }
      VueScrollTo.scrollTo('#program-form', 150, options)
    },
    async created () {
      this.privateProgram = {}
      if (this.program) {
        this.isNew = false
        this.privateProgram = Object.assign({}, this.program)
        if (isNil(this.program.notary)) {
          this.notary = Object.assign({}, emptyNotary)
        } else {
          this.notary = Object.assign({}, emptyNotary, this.program.notary)
        }
        this.program.tax_dispositifs.forEach(x => {
          if (x in this.taxDispositifsData) {
            this.selectedTaxDispositifs.push(this.taxDispositifsData[x].value)
          }
        })
        this.program.certifications.forEach(x => {
          this.selectedCertifications.push(this.programCertifications[x].value)
        })
        this.location = Object.assign({}, this.program.location)
        this.selectedStatusData = this.program.status
        this.descriptions = this.privateProgram.descriptions && this.privateProgram.descriptions.length ? this.privateProgram.descriptions : [Object.assign({}, emptyDescriptions)]
        this.address = Object.assign({}, this.program.address)
        this.addressCompany = Object.assign({}, this.program.promoteur_info.company_address)
        this.addressRep = Object.assign({}, this.program.promoteur_info.rep_address)
        this.notaryAddress = Object.assign({}, this.program.promoteur_info.rep_address)
        this.addressNotaire = Object.assign({}, this.program.notary.address)
        this.completeAddress = true
        this.autoValidation = this.privateProgram.auto_validation
        this.isOptionable = this.privateProgram.is_optionable
        this.forceLivrable = this.privateProgram.livraison_validated
        this.forceActabilite = this.privateProgram.actabilite_validated
        this.pictures = this.privateProgram.pictures.slice()
        this.videos = this.privateProgram.videos && this.privateProgram.videos.length ? this.privateProgram.videos : [Object.assign({}, emptyVideo)]
        if (this.privateProgram.date_actabilite) {
          this.actabilite = this.privateProgram.date_actabilite.toString().substring(0, 4)
          this.actabiliteTrimestre = this.privateProgram.date_actabilite.toString().substring(4, 5)
        }
        if (this.privateProgram.date_livraison) {
          this.livraison = this.privateProgram.date_livraison.toString().substring(0, 4)
          this.livraisonTrimestre = this.privateProgram.date_livraison.toString().substring(4, 5)
        }
        if (this.privateProgram.debut_travaux) {
          this.debut_travaux = this.privateProgram.debut_travaux.toString().substring(0, 4)
          this.debutTravaux = this.privateProgram.debut_travaux.toString().substring(4, 5)
        }
        if (this.privateProgram.fin_travaux) {
          this.fin_travaux = this.privateProgram.fin_travaux.toString().substring(0, 4)
          this.finTravaux = this.privateProgram.fin_travaux.toString().substring(4, 5)
        }
        this.initDocuments(this.program)
        this.updateHelperText()
      } else {
        this.privateProgram = Object.assign({}, emptyProgram)
        this.initDocuments(this.privateProgram)
        this.selectedStatusData = 'draft'
        this.notary = Object.assign({}, emptyNotary)
        if (this.$route.query && this.$route.query.promoteur) {
          const { data } = await this.$api.promoteurService.getOne(this.$route.query.promoteur)
          this.promoteurChange = data
        }
      }
      if (this.isDistributeurMode) {
        this.promoteurs = this.promoteursList.slice()
      }
      if (this.selectPanel) {
        this.panel = this.selectPanel
      }
      this.getValidOptionHelper()
      if ('check' in this.$route.query) {
        this.hasCheck = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/program/ProgramForm.vue